import GeneralComponent from '../components/GeneralComponent';
import SyosPageComponent from '../components/SyosPageComponent';
import { ISyosLabels } from './types';

export default function buildStandardSyosLabels(): ISyosLabels {
  return {
    legendLabel: SyosPageComponent.legendLabel,
    priceRangeSeparator: GeneralComponent.priceRangeSeparator,
    seatStatusSelected: SyosPageComponent.labelSeatStatusSelected,
    seatStatusUnavailable: SyosPageComponent.labelSeatStatusUnavailable,
    seatTypeNotForSale: SyosPageComponent.labelSeatTypeNotForSale,
    seatTypeSpecial: SyosPageComponent.labelSeatTypeSpecial,
    seatTypeWheelchair: SyosPageComponent.labelSeatTypeWheelchair,
    addToCartButton: SyosPageComponent.addToCartButton,
    selectedSeatsHeader: SyosPageComponent.selectedSeatsHeader,
    seatInfoPriceTypeListHeading: SyosPageComponent.headingAvailableTicketTypes,
    selectedSeatsLabel: SyosPageComponent.SelectedSeatsLabel,
    selectedSeatsSeparatorText: SyosPageComponent.SelectedSeatsSeparatorText,
    remainingSeatsLabel: SyosPageComponent.RemainingSeatsLabel,
    selectSeatHeading: SyosPageComponent.headingChooseTicketType,
    singleTicketTypesForSeatLabel: SyosPageComponent.headingAvailableTicketTypes,
    multipleTicketTypesForSeatLabel: SyosPageComponent.headingAvailableTicketTypes,
    selectSeatCloseButtonLabel: 'Close',
    selectSeatSubmitButtonLabel: SyosPageComponent.SelectSeatSubmitButtonLabel,
    modalCloseButtonLabel: 'Close',
  };
}
